
//Représente les paramètres de mise à jour du tri des colonnes d’un utilisateur
export class ASeMettreAJourTriColonnesUtilisateurParametres 
{
  //Création
  constructor () 
  {
    this.trisColonnes = [];
  }

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Tris des colonnes
  public trisColonnes: ASeTriColonne[];
}

//Représente le tri d’une colonne
export class ASeTriColonne 
{
  //Identifiant
  public identifiant!: string;

  //Ordre
  public ordre!: number;

  //Sens du tri
  public sens!: string;
}
